<div class="content-container bg-white">
    <h1>{{ (!serviceId ? 'services.manage.createServiceTitle' : 'services.manage.editServiceTitle') | translate }}</h1>

    @if (!!serviceConfig && hasServiceEditAccess()) {
        <div>
            <div class="btn-bar">
                <button class="btn btn-outline-secondary"
                        (click)="backToServiceList()"
                        translate="services.actions.back">
                </button>
                @if (!!serviceId && hasGestionServicesPermission()) {
                    <button class="btn btn-outline-danger"
                            (click)="deleteService()"
                            translate="services.actions.delete">
                    </button>
                }
            </div>
        </div>

        <form [formGroup]="serviceForm" name="serviceForm">
            <div class="row">
                <!-- serviceId -->
                @if (service?.serviceId) {
                    <div class="col-12 col-md-6">
                        <label class="form-label" for="serviceId">
                            {{ 'services.manage.serviceId' | translate }}
                        </label>
                        <input class="form-control " id="serviceId" type="text"
                               pattern="{{ FormUtils.textInputPattern }}"
                               placeholder="{{ service.serviceId }}"
                               formControlName="serviceId">
                    </div>
                }

                <!-- serviceState -->
                <div class="col-12 col-md-3">
                    <label class="form-label" translate="services.view.state"></label>
                    <div class="form-check form-switch">
                        <input class="form-check-input" id="state" type="checkbox" name="state"
                               formControlName="serviceState">
                        <label class="form-check-label" for="state">
                            {{ (serviceState.value ? 'services.view.available' : 'services.view.unavailable') | translate }}
                        </label>
                    </div>
                </div>

                <!-- Bookable -->
                @if (canConfigureBookable()) {
                    <div class="col-12 col-md-3">
                        <label class="form-label" translate="services.bookable"></label>
                        <div class="form-check form-switch">
                            <input class="form-check-input" id="bookable" type="checkbox" name="bookable"
                                   formControlName="bookable">
                            <label class="form-check-label" for="bookable">
                                {{ (bookable.value ? 'common.yes' : 'common.no') | translate }}
                            </label>
                        </div>
                    </div>
                }

                <!-- Category -->
                <div class="col-12 col-md-6">
                    <label class="form-label" for="category">
                        {{ 'services.manage.category' | translate }}*
                    </label>
                    <select class="form-control form-select" id="category" name="category" formControlName="category">
                        @for (cat of categories; track cat) {
                            <option
                                [value]="cat.id">{{ cat['name' + this.crtLang.toLocaleUpperCase()] }}
                            </option>
                        }
                    </select>

                    <app-form-error [control]="category"></app-form-error>
                </div>

                <!-- Code -->
                <div class="col-12 col-md-6">
                    <label class="form-label" for="code">{{ 'services.manage.code' | translate }}*</label>
                    <input class="form-control" id="code" name="code" type="text"
                           pattern="{{FormUtils.textInputPattern}}"
                           maxlength="3"
                           placeholder="{{ 'services.placeholder.code' | translate }}"
                           onkeyup="this.value = this.value.toUpperCase();"
                           formControlName="code">

                    <app-form-error [control]="code"></app-form-error>
                </div>
            </div>
            <hr class="mt-4 mb-4">

            <!-- Names -->
            <div class="row">
                <div class="col-12 col-md-6">
                    <label class="form-label" for="nameFR">{{ 'services.manage.nameFR' | translate }}*</label>
                    <input class="form-control" id="nameFR" name="nameFR" type="text"
                           pattern="{{ FormUtils.textInputPattern }}"
                           maxlength="25"
                           placeholder="{{ 'services.placeholder.nameFR' | translate }}"
                           formControlName="nameFR"/>

                    <app-form-error [control]="nameFR"></app-form-error>
                </div>

                @if (customerConfigService.isLanguageAvailable('de')) {
                    <div class="col-12 col-md-6">
                        <label class="form-label" for="nameDE">{{ 'services.manage.nameDE' | translate }}</label>
                        <input id="nameDE" type="text" class="form-control" name="nameDE"
                               pattern="{{ FormUtils.textInputPattern }}"
                               maxlength="25"
                               placeholder="{{ 'services.placeholder.nameDE' | translate }}"
                               formControlName="nameDE"/>
                    </div>
                }

                @if (customerConfigService.isLanguageAvailable('it')) {
                    <div class="col-12 col-md-6">
                        <label class="form-label" for="nameIT">{{ 'services.manage.nameIT' | translate }}</label>
                        <input id="nameIT" type="text" class="form-control" name="nameIT"
                               pattern="{{ FormUtils.textInputPattern }}" maxlength="25"
                               placeholder="{{ 'services.placeholder.nameIT' | translate }}"
                               formControlName="nameIT"/>
                    </div>
                }

                @if (customerConfigService.isLanguageAvailable('en')) {
                    <div class="col-12 col-md-6">
                        <label class="form-label" for="nameEN">{{ 'services.manage.nameEN' | translate }}</label>
                        <input id="nameEN" type="text" class="form-control" name="nameEN"
                               pattern="{{ FormUtils.textInputPattern }}"
                               maxlength="25"
                               placeholder="{{ 'services.placeholder.nameEN' | translate }}"
                               formControlName="nameEN"/>
                    </div>
                }
            </div>
            <hr class="mt-4 mb-4">

            <!-- Description -->
            <div class="row">
                <div class="col-12 col-md-6">
                    <label class="form-label"
                           for="descriptionFR">{{ 'services.manage.descriptionFR' | translate }}</label>
                    <textarea id="descriptionFR" type="textarea" class="form-control"
                              name="descriptionFR"
                              maxlength="1000"
                              rows="3"
                              placeholder="{{ 'services.placeholder.descriptionFR' | translate }}"
                              formControlName="descriptionFR"></textarea>
                </div>

                @if (customerConfigService.isLanguageAvailable('de')) {
                    <div class="col-12 col-md-6">
                        <label class="form-label"
                               for="descriptionDE">{{ 'services.manage.descriptionDE' | translate }}</label>
                        <textarea id="descriptionDE" type="text" class="form-control"
                                  pattern="{{FormUtils.textInputPattern}}"
                                  name="descriptionDE"
                                  maxlength="1000"
                                  rows="3"
                                  placeholder="{{ 'services.placeholder.descriptionDE' | translate }}"
                                  formControlName="descriptionDE"></textarea>
                    </div>
                }

                @if (customerConfigService.isLanguageAvailable('it')) {
                    <div class="col-12 col-md-6">
                        <label class="form-label"
                               for="descriptionIT">{{ 'services.manage.descriptionIT' | translate }}</label>
                        <textarea id="descriptionIT" type="text" class="form-control"
                                  name="descriptionIT"
                                  pattern="{{FormUtils.textInputPattern}}"
                                  maxlength="1000"
                                  rows="3"
                                  placeholder="{{ 'services.placeholder.descriptionIT' | translate }}"
                                  formControlName="descriptionIT"></textarea>
                    </div>
                }

                @if (customerConfigService.isLanguageAvailable('en')) {
                    <div class="col-12 col-md-6">
                        <label class="form-label"
                               for="descriptionEN">{{ 'services.manage.descriptionEN' | translate }}</label>
                        <textarea id="descriptionEN" type="text" class="form-control"
                                  pattern="{{FormUtils.textInputPattern}}"
                                  name="descriptionEN"
                                  maxlength="1000"
                                  rows="3"
                                  placeholder="{{ 'services.placeholder.descriptionEN' | translate }}"
                                  formControlName="descriptionEN"></textarea>
                    </div>
                }
            </div>
            <hr class="mt-4 mb-4">

            <!-- Instruction -->
            <div class="row">
                <div class="col-12 col-md-6">
                    <label class="form-label"
                           for="instructionFR">{{ 'services.manage.instructionFR' | translate }}</label>
                    <textarea id="instructionFR" type="text" class="form-control"
                              name="instructionFR"
                              pattern="{{FormUtils.textInputPattern}}"
                              maxlength="1000"
                              rows="3"
                              placeholder="{{ 'services.placeholder.instructionFR' | translate }}"
                              formControlName="instructionFR"></textarea>
                </div>

                @if (customerConfigService.isLanguageAvailable('de')) {
                    <div class="col-12 col-md-6">
                        <label class="form-label"
                               for="instructionDE">{{ 'services.manage.instructionDE' | translate }}</label>
                        <textarea id="instructionDE" type="text" class="form-control"
                                  name="instructionDE"
                                  maxlength="1000"
                                  rows="3"
                                  placeholder="{{ 'services.placeholder.instructionDE' | translate }}"
                                  formControlName="instructionDE"></textarea>
                    </div>
                }

                @if (customerConfigService.isLanguageAvailable('it')) {
                    <div class="col-12 col-md-6">
                        <label class="form-label"
                               for="instructionIT">{{ 'services.manage.instructionIT' | translate }}</label>
                        <textarea id="instructionIT" type="text" class="form-control"
                                  name="instructionIT"
                                  maxlength="1000"
                                  rows="3"
                                  placeholder="{{ 'services.placeholder.instructionIT' | translate }}"
                                  formControlName="instructionIT"></textarea>
                    </div>
                }

                @if (customerConfigService.isLanguageAvailable('en')) {
                    <div class="col-12 col-md-6">
                        <label class="form-label"
                               for="instructionEN">{{ 'services.manage.instructionEN' | translate }}</label>
                        <textarea id="instructionEN" type="text" class="form-control"
                                  name="instructionEN"
                                  maxlength="1000"
                                  rows="3"
                                  placeholder="{{ 'services.placeholder.instructionEN' | translate }}"
                                  formControlName="instructionEN"></textarea>
                    </div>
                }
            </div>

            <!-- Activation fields -->
            @if (canConfigureActivation()) {
                <div>
                    <hr class="mt-4 mb-4">
                    <h4 translate="services.manage.activationSubtitle"></h4>
                    <div class="row">
                        <!-- Authentication Method -->
                        <div class="col-12 col-md-6">
                            <label class="form-label"
                                   for="authenticationMethod">{{ 'services.manage.authenticationMethod' | translate }}</label>
                            <ng-multiselect-dropdown id="authenticationMethod" style="width: 100%;"
                                                     placeholder="{{ 'common.multiselect.placeholder' | translate }}"
                                                     [formControl]="authenticationMethod"
                                                     [settings]="authenticationMethodDropdownSettings"
                                                     [data]="authenticationMethodDropdownSources">
                            </ng-multiselect-dropdown>
                        </div>

                        <!-- Minimal Wallet Balance -->
                        @if (canConfigureMinimalWalletBalance()) {
                            <div class="col-12 col-md-6">
                                <label class="form-label"
                                       for="minimalWalletBalanceRequired">{{ 'services.manage.minimalWalletBalanceRequired' | translate }}
                                    *</label>
                                <div class="input-group">
                                    <span class="input-group-text">CHF</span>
                                    <input class="form-control" id="minimalWalletBalanceRequired"
                                           name="minimalWalletBalanceRequired"
                                           type="number"
                                           (keydown)="FormUtils.validateInputNumberLength($event, 10)"
                                           placeholder="{{ 'services.placeholder.minimalWalletBalanceRequired' | translate }}"
                                           formControlName="minimalWalletBalanceRequired">
                                </div>
                                <app-form-error [control]="minimalWalletBalanceRequired"></app-form-error>
                            </div>
                        }

                        <!-- Amount to reserve for the consumption of a service -->
                        @if (canConfigureAmountToReserveForServiceConsumption()) {
                            <div class="col-12 col-md-6">
                                <label class="form-label"
                                       for="amountToReserveForServiceConsumption">{{ 'services.manage.amountToReserveForServiceConsumption' | translate }}
                                    *</label>
                                <div class="input-group">
                                    <span class="input-group-text">CHF</span>
                                    <input class="form-control" id="amountToReserveForServiceConsumption"
                                           name="amountToReserveForServiceConsumption"
                                           type="number"
                                           (keydown)="FormUtils.validateInputNumberLength($event, 10)"
                                           placeholder="{{ 'services.placeholder.amountToReserveForServiceConsumption' | translate }}"
                                           formControlName="amountToReserveForServiceConsumption">
                                </div>
                                <app-form-error [control]="amountToReserveForServiceConsumption"></app-form-error>
                            </div>
                        }

                        <!-- Impulse duration -->
                        @if (canConfigureImpulseDuration()) {
                            <div class="col-12 col-md-6">
                                <label class="form-label" for="impulseDuration">
                                    {{ 'services.impulseDuration' | translate }}

                                    @if (serviceConfig.serviceType === ServiceType.TimeLimited) {
                                        <span>*</span>
                                    }
                                </label>

                                <input class="form-control"
                                       id="impulseDuration" type="number"
                                       pattern="^[0-9]*$"
                                       (keydown)="FormUtils.validateInputNumberLength($event, 8)"
                                       name="impulseDuration" min="1" max="{{ maxImpulseDuration?.value }}"
                                       formControlName="impulseDuration">

                                <app-form-error [control]="impulseDuration"></app-form-error>
                            </div>

                            <div class="col-12 col-md-6">
                                <label class="form-label" for="impulseDurationUnit">
                                    {{ 'services.impulseDurationUnit' | translate }}

                                    @if (serviceConfig.serviceType === ServiceType.TimeLimited) {
                                        <span>*</span>
                                    }
                                </label>

                                <select class="form-control form-select" name="impulseDurationUnit"
                                        id="impulseDurationUnit"
                                        formControlName="impulseDurationUnit">
                                    @for (impulseDurationUnit of impulseDurationUnits; track impulseDurationUnit) {
                                        <option
                                            [ngValue]="impulseDurationUnit">{{ 'common.impulseDurationUnit.' + impulseDurationUnit | translate }}
                                        </option>
                                    }
                                </select>
                            </div>

                            @if (serviceConfig.serviceType === ServiceType.TimeLimited) {
                                <div class="col-12 col-md-6">
                                    <label class="form-label" for="maxImpulseDuration">
                                        {{ 'services.maxImpulseDuration' | translate }}*
                                    </label>
                                    <input class="form-control"
                                           id="maxImpulseDuration" type="number"
                                           pattern="^[0-9]*$"
                                           (keydown)="FormUtils.validateInputNumberLength($event, 8)"
                                           name="maxImpulseDuration" min="{{ impulseDuration.value }}"
                                           formControlName="maxImpulseDuration">

                                    <app-form-error [control]="maxImpulseDuration"></app-form-error>
                                </div>
                            }
                        }
                    </div>
                </div>
            }

            <!-- ROLES -->
            @if (canConfigureRoles()) {
                <div>
                    <hr class="mt-4 mb-4">
                    <h4 translate="services.roles.role"></h4>

                    <app-custom-role-management
                        formControlName="customRoles"
                        [enablePublicAccess]="canConfigurePublicRole()"
                        [enableAllCustomers]="true"
                        [validationRequired]="true">
                    </app-custom-role-management>
                </div>
            }

            <!-- EXPLOITANTS (admin only) -->
            @if (hasGestionServicesPermission()) {
                <hr class="mt-4 mb-4">
                <h4>{{ 'Exploitants' | translate }}</h4>
                <div class="row">
                    <div class="col-12">
                        <label class="form-label" for="selectedExploitants">
                            {{ 'AjouterUnExploitant' | translate }}
                        </label>
                        <ng-multiselect-dropdown id="selectedExploitants" style="width: 100%;"
                                                 placeholder="{{ 'common.multiselect.placeholder' | translate }}"
                                                 [formControl]="selectedExploitants"
                                                 [settings]="exploitantsDropdownSettings"
                                                 [data]="exploitantsDropdownSources">
                        </ng-multiselect-dropdown>
                    </div>
                </div>
            }

            <div class="btn-bar">
                <button class="btn btn-outline-secondary"
                        (click)="backToServiceList()"
                        translate="services.actions.back">
                </button>
                <button class="btn btn-primary" type="submit"
                        [disabled]="!(serviceForm.valid && isFormValid())"
                        (click)="createOrEditService()"
                        translate="common.save">
                </button>
            </div>
        </form>
    }

    @if (service) {
        <div #serviceChildrenSection>
            @if (hasServiceEditAccess()) {
                <!-- Image -->
                <hr class="mt-4 mb-4">
                <div id="sectionImage">
                    <h4 translate="services.manage.image"></h4>
                    <p [translateParams]="{ImageMaxSize: imageMaxSizeInKB}"
                       translate="common.imageMaxSize"></p>
                    <div class="row">
                        <div class="col-12">
                            <input type="file" accept="{{supportedImage}}"
                                   (change)="fileSelected($event.target['files'])"
                                   [disabled]="service === null || service.serviceId === null">

                            @if (!imageValid) {
                                <p class="text-danger font-italic"
                                   [translateParams]="{ImageMaxSize: imageMaxSizeInKB}"
                                   translate="services.manage.imageToBig"></p>
                            }
                        </div>
                    </div>

                    <div class="btn-bar">
                        <button class="btn btn-primary"
                                [disabled]="!imageToUpload || (service === null || service.serviceId === null)"
                                (click)="uploadImage()"
                                translate="common.saveIllustration">
                        </button>
                    </div>

                    @if (imageUrl) {
                        <div class="row">
                            <div class="col-6">
                                <img class="img-thumbnail" src="{{imageUrl}}" alt="Illustration">
                            </div>
                        </div>
                    }
                </div>

                <!-- TARIFF -->
                @if (canConfigureTariffs()) {
                    <hr class="mt-4 mb-4">
                    <app-tariff-management [serviceConfig]="serviceConfig"
                                           [serviceId]="serviceId">
                    </app-tariff-management>
                }

                <!-- Availability Range -->
                @if (canConfigureAvailabilityRanges()) {
                    <hr class="mt-4 mb-4">
                    <app-availability-range [serviceId]="serviceId"></app-availability-range>
                }

                <!-- Booking Configuration -->
                @if (service.bookable && bookable.value && isCurrentBackofficeServiceExploitant()) {
                    <!-- check "service.bookable" to ensure we save the service before when we activate bookable feature -->
                    <hr class="mt-4 mb-4">
                    <h4 translate="services.bookingSubtitle"></h4>
                    <app-booking-service-configuration [serviceId]="serviceId"></app-booking-service-configuration>
                }

                <!-- ITEMS -->
                @if (service.bookable && bookable.value && isCurrentBackofficeServiceExploitant()) {
                    <hr class="mt-4 mb-4">
                    <app-item-management [serviceId]="serviceId"></app-item-management>
                }

                <!-- HYDROWASH -->
                @if (serviceConfig.serviceType === serviceType.Hydrowash && isCurrentBackofficeServiceExploitant()) {
                    <hr class="mt-4 mb-4">
                    <app-hydrowash-management [serviceId]="serviceId"></app-hydrowash-management>
                }

                <!-- WIFI -->
                @if (serviceConfig.serviceType === serviceType.Wifi && isCurrentBackofficeServiceExploitant()) {
                    <hr class="mt-4 mb-4">
                    <app-wifi-management [service]="service"></app-wifi-management>
                }

                <!-- Door Groups — exploitant of the service only -->
                @if (isAccessControlServiceType() && isCurrentBackofficeServiceExploitant()) {
                    <hr class="mt-4 mb-4">
                    <app-door-group [serviceId]="serviceId"></app-door-group>
                }

                <!-- Map -->
                @if (canConfigureMap() && isCurrentBackofficeServiceExploitant()) {
                    <hr class="mt-4 mb-4">
                    <app-manage-map [serviceId]="serviceId"></app-manage-map>
                }

                <!-- Mooring Places -->
                @if (serviceConfig.serviceType === serviceType.MooringPlace && isCurrentBackofficeServiceExploitant()) {
                    <hr class="mt-4 mb-4">
                    <app-edit-mooring-place [serviceId]="serviceId"></app-edit-mooring-place>
                }

                <!-- Public Lighting -->
                @if (serviceConfig.serviceType === serviceType.PublicLighting && isCurrentBackofficeServiceExploitant()) {
                    <hr class="mt-4 mb-4">
                    <app-public-lighting-management [serviceId]="serviceId"></app-public-lighting-management>
                }

                <!-- MEASURING POINTS - USER -->
                @if (canConfigureCustomerMeasuringPoint() && isCurrentBackofficeServiceExploitant()) {
                    <div>
                        <hr class="mt-4 mb-4">
                        <h4 translate="measuringPoints.customerPointTitle"></h4>
                        <div class="btn-bar">
                            <button class="btn btn-primary"
                                    (click)="assignNewMeasuringPoint(customerMeasuringPointType)"
                                    translate="measuringPoints.actions.assignToService">
                            </button>
                        </div>

                        @if (customerMeasuringPoints.length > 0) {
                            <p class="text-center"
                               [translateParams]="{MaxItemCount: 20}"
                               translate="measuringPoints.table.itemLimit"></p>
                        }

                        @if (keepDisplayCustomerMeasuringPointTable || customerMeasuringPoints.length > 0) {
                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <label class="form-label" for="searchCustomerMeasuringPoint"
                                           translate="measuringPoints.table.filter.measuringPoint"></label>

                                    <app-search-measuring-point id="searchCustomerMeasuringPoint"
                                                                (selectedMeasuringPointEvent)="searchByCustomerMeasuringPointId($event)"
                                                                [measuringPointTypes]="[customerMeasuringPointType]"
                                                                [serviceId]="service.serviceId"></app-search-measuring-point>
                                </div>

                                <div class="col-12 col-md-6">
                                    <label class="form-label" for="searchCustomer"
                                           translate="measuringPoints.table.filter.user"></label>
                                    <app-search-customer id="searchCustomer"
                                                     (selectedCustomerEvent)="searchByCustomerId($event)"></app-search-customer>
                                </div>
                            </div>
                        }

                        <div class="table-responsive mt-4">
                            <table class="table table-striped"
                                   [attr.aria-label]="'measuringPoints.customerPointTitle' | translate">
                                <thead>
                                <tr>
                                    <th scope="col" style="min-width: 300px"
                                        translate="measuringPoints.table.name"></th>
                                    <th scope="col" style="min-width: 300px"
                                        translate="measuringPoints.table.user">
                                    </th>
                                    <th scope="col" style="min-width: 150px"
                                        translate="measuringPoints.table.state">
                                    </th>
                                    <th scope="col" style="min-width:125px"></th>
                                </tr>
                                </thead>
                                <tbody>
                                    @if (customerMeasuringPoints.length === 0) {
                                        <tr>
                                            <td>-</td>
                                            <td>-</td>
                                            <td>-</td>
                                            <td></td>
                                        </tr>
                                    }

                                    @for (measuringPoint of customerMeasuringPoints; track measuringPoint) {
                                        <tr>
                                            <td>{{ printMeasuringPointName(measuringPoint) }}</td>
                                            <td>{{ printMeasuringPointCustomer(measuringPoint.customer) }}</td>
                                            <td>{{ 'common.measuringPointUsageState.' + measuringPoint.measuringPointUsageState | translate }}</td>
                                            <td class="text-end">
                                                <button class="btn btn-link btn-sm"
                                                        (click)="editMeasuringPointCustomerAssignation(measuringPoint)"
                                                        title="{{ (measuringPoint.customer ? 'measuringPoints.tooltip.reassignCustomer' : 'measuringPoints.tooltip.assignCustomer') | translate }}">
                                                    @if (measuringPoint.customer) {
                                                        <fa-icon [icon]="icons.userEdit"></fa-icon>
                                                    } @else {
                                                        <fa-icon [icon]="icons.userPlus"></fa-icon>
                                                    }
                                                </button>

                                                <button class="btn btn-link btn-sm"
                                                        [disabled]="!measuringPoint.customer"
                                                        (click)="unassignMeasuringPointFromCustomer(measuringPoint)"
                                                        title="{{'measuringPoints.tooltip.unassignCustomer' | translate}}">
                                                    <fa-icon [icon]="icons.userSlash"></fa-icon>
                                                </button>

                                                <button class="btn btn-link btn-sm"
                                                        [disabled]="measuringPoint.customer"
                                                        (click)="unassignMeasuringPointFromService(measuringPoint)"
                                                        title="{{'measuringPoints.tooltip.unassign' | translate}}">
                                                    <fa-icon [icon]="icons.trash"></fa-icon>
                                                </button>
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                }


                <!-- CRANING - Craning services -->
                @if (serviceConfig.serviceType === serviceType.CraningAndWinterizing && isCurrentBackofficeServiceExploitant()) {
                    <hr class="mt-4 mb-4">
                    <app-craning-service-management [serviceId]="serviceId"></app-craning-service-management>
                }
            }

            <!-- MEASURING POINTS - ADMIN -->
            @if (rolesService.hasRoleSuperAdmin() && canConfigureAdminMeasuringPoint()) {
                <hr class="mt-4 mb-4">
                <h4 translate="measuringPoints.adminPointTitle"></h4>
                <h5>
                    @switch (crtLang) {
                        @case ('fr') {
                            <span>{{ service.nameFR }}</span>
                        }
                        @case ('de') {
                            <span>{{ service.nameDE }}</span>
                        }
                        @case ('it') {
                            <span>{{ service.nameIT }}</span>
                        }
                        @case ('en') {
                            <span>{{ service.nameEN }}</span>
                        }
                    }
                </h5>

                <div class="btn-bar">
                    <button class="btn btn-primary"
                            (click)="assignNewMeasuringPoint(adminMeasuringPointType)"
                            translate="measuringPoints.actions.assignToService">
                    </button>
                </div>

                @if (adminMeasuringPoints.length > 0) {
                    <p class="text-center"
                       [translateParams]="{MaxItemCount: 20}"
                       translate="measuringPoints.table.itemLimit"></p>

                    <div class="row">
                        <div class="col-12 col-md-6">
                            <label class="form-label" for="searchMeasuringPoint"
                                   translate="measuringPoints.table.filter.measuringPoint"></label>
                            <app-search-measuring-point id="searchMeasuringPoint"
                                                        (selectedMeasuringPointEvent)="searchByAdminMeasuringPointId($event)"
                                                        [measuringPointTypes]="[adminMeasuringPointType]"
                                                        [serviceId]="service.serviceId"></app-search-measuring-point>
                        </div>
                    </div>
                }

                <div class="table-responsive mt-4">
                    <table class="table table-striped"
                           [attr.aria-label]="'measuringPoints.adminPointTitle' | translate">
                        <thead>
                        <tr>
                            <th scope="col" style="min-width: 400px" translate="measuringPoints.table.name"></th>
                            <th scope="col" style="min-width: 400px" translate="measuringPoints.table.state"></th>
                            <th scope="col" style="min-width:125px"></th>
                        </tr>
                        </thead>
                        <tbody>
                            @if (adminMeasuringPoints.length === 0) {
                                <tr>
                                    <td>-</td>
                                    <td>-</td>
                                    <td></td>
                                </tr>
                            }

                            @for (adminMeasuringPoint of adminMeasuringPoints; track adminMeasuringPoint) {
                                <tr>
                                    <td>{{ printMeasuringPointName(adminMeasuringPoint) }}</td>
                                    <td>{{ 'common.measuringPointUsageState.' + adminMeasuringPoint.measuringPointUsageState | translate }}</td>
                                    <td class="text-end">
                                        <button class="btn btn-link btn-sm"
                                                (click)="openQrCode(adminMeasuringPoint)"
                                                title="{{ 'common.tooltip.displayQrCode' | translate }}">
                                            <fa-icon [icon]="icons.qrcode"></fa-icon>
                                        </button>
                                        <button class="btn btn-link btn-sm"
                                                (click)="unassignMeasuringPointFromService(adminMeasuringPoint)"
                                                title="{{ 'measuringPoints.tooltip.unassign' | translate }}">
                                            <fa-icon [icon]="icons.trash"></fa-icon>
                                        </button>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            }

            <!-- WEBCAM -->
            @if (serviceConfig.serviceType === serviceType.Webcam && isCurrentBackofficeServiceExploitant()) {
                <hr class="mt-4 mb-4">
                <app-webcam-management [serviceId]="serviceId"></app-webcam-management>
            }

            <!-- Point Of Sale -->
            @if (serviceConfig.serviceType === serviceType.PointOfSale && isCurrentBackofficeServiceExploitant()) {
                <hr class="mt-4 mb-4">
                <app-point-of-sale-management [serviceId]="serviceId"></app-point-of-sale-management>
            }

            <!-- Dumpster -->
            @if (serviceConfig.serviceType === serviceType.WasteManagement && isCurrentBackofficeServiceExploitant()) {
                <hr class="mt-4 mb-4">
                <app-dumpster-management [serviceId]="serviceId"></app-dumpster-management>
            }

            <!-- Charging Station -->
            @if (serviceConfig.serviceType === serviceType.ChargingStations) {
                <hr class="mt-4 mb-4">
                <app-charging-station-management
                    [serviceId]="serviceId"
                    [isExploitant]="isCurrentBackofficeServiceExploitant()"></app-charging-station-management>
            }

            <div class="btn-bar">
                <button class="btn btn-outline-secondary"
                        (click)="backToServiceList()"
                        translate="services.actions.back">
                </button>
            </div>
        </div>
    }
</div>
